const devBaseURL = "https://mp.knet.bf";
const proBaseURL = "https://mp.knet.bf";
// const devBaseURL = "http://localhost";
// const proBaseURL = "http://localhost";
export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL: proBaseURL;

export const TIMEOUT = 100000;



// WEBPACK FOOTER //
// ./src/api/config.js